<template>
    <backend-layout title="Subscriptions">
        <section class="py-6 px-0 md:px-6">
            <div class="grid grid-cols-1 gap-6 md:grid-cols-3">
                <div
                    class="rounded-lg flex flex-col bg-white border border-gray-100 dark:bg-gray-900 dark:border-gray-900 lg:my-12 xl:ml-12">
                    <header class="border-b border-gray-100 dark:border-gray-700 p-6">
                        <div class="justify-between items-center flex">
                            <div class="flex flex-shrink items-center justify-center">
                                <div>
                                    <div class="justify-end items-center flex">
                                        <div class="flex flex-shrink items-center justify-center"><h3 class="text-4xl">
                                            $ </h3></div>
                                        <div class="flex flex-shrink items-center justify-center"><h1
                                            class="text-5xl font-black">5</h1></div>
                                        <div class="flex flex-shrink items-center justify-center"><h1
                                            class="text-xl text-gray-500 dark:text-gray-400"> /mo</h1></div>
                                    </div>
                                    <!--                                    <div-->
                                    <!--                                        class="inline-flex items-center border py-0.5 px-2 text-xs rounded-lg bg-gray-100 text-black border-gray-200 dark:border-gray-400 mr-1.5 last:mr-0">-->
                                    <!--                                        &lt;!&ndash;&ndash;&gt;<span>Individuals</span>-->
                                    <!--                                    </div>-->
                                </div>
                            </div>
                            <div class="flex flex-shrink items-center justify-center">
                                <div class="justify-between items-center flex">
                                    <div class="flex flex-shrink items-center justify-center">
                                        <div class="text-right"><h1 class="text-2xl">Starter</h1>
                                            <!--                                            <h1 class="text-lg text-gray-500 dark:text-gray-400">Good start</h1>-->
                                        </div>
                                    </div>
                                    <div class="flex flex-shrink items-center justify-center"><span
                                        class="inline-flex justify-center items-center w-16 h-16 ml-6 lg:hidden"><svg
                                        viewBox="0 0 24 24" width="48" height="48" class="inline-block"><path
                                        fill="currentColor"
                                        d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z"></path></svg>
                                        <!----></span></div>
                                </div>
                            </div>
                        </div>
                    </header>
                    <div class="lg:block p-6 flex-1">
                        <div class="space-y-6">
                            <div class="flex items-center"><span
                                class="inline-flex justify-center items-center w-8 h-8"><svg viewBox="0 0 24 24"
                                                                                             width="24" height="24"
                                                                                             class="inline-block"><path
                                fill="currentColor" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"></path></svg>
                                <!----></span><span class="text-lg ml-3"><b>3</b> Campaigns</span></div>
                            <div class="flex items-center"><span
                                class="inline-flex justify-center items-center w-8 h-8"><svg viewBox="0 0 24 24"
                                                                                             width="24" height="24"
                                                                                             class="inline-block"><path
                                fill="currentColor" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"></path></svg>
                                <!----></span><span class="text-lg ml-3"><b>5</b> Referrers per Campaign</span></div>
                            <div class="flex items-center"><span
                                class="inline-flex justify-center items-center w-8 h-8"><svg viewBox="0 0 24 24"
                                                                                             width="24" height="24"
                                                                                             class="inline-block"><path
                                fill="currentColor" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"></path></svg>
                                <!----></span><span class="text-lg ml-3"><b>Analytics</b> (visits & locations)</span>
                            </div>
                        </div>
                    </div>
                    <div class="border-gray-100 dark:border-gray-700 lg:block p-6 border-t">
                        <div class="flex items-center justify-start flex-wrap -mb-3">
                            <paddle-button :url="starterPayLink" :plan="'starter'">Subscribe</paddle-button>
                            <!--                            <a href="#!" class="ml-4 paddle_button" data-override="{{ payLink }}">-->
                            <!--                                Paddle Checkout-->
                            <!--                            </a>-->
                        </div>
                    </div>
                </div>
                <div
                    class="rounded-lg flex flex-col bg-white border border-gray-100 dark:bg-gray-900 dark:border-gray-900 shadow-2xl">
                    <header class="border-b border-gray-100 dark:border-gray-700 p-6">
                        <div class="justify-between items-center flex">
                            <div class="flex flex-shrink items-center justify-center">
                                <div>
                                    <div class="justify-end items-center flex">
                                        <div class="flex flex-shrink items-center justify-center"><h3 class="text-4xl">
                                            $ </h3></div>
                                        <div class="flex flex-shrink items-center justify-center"><h1
                                            class="text-5xl font-black">15</h1></div>
                                        <div class="flex flex-shrink items-center justify-center"><h1
                                            class="text-xl text-gray-500 dark:text-gray-400"> /mo</h1></div>
                                    </div>
                                    <!--                                    <div-->
                                    <!--                                        class="inline-flex items-center border py-0.5 px-2 text-xs rounded-lg bg-blue-500 text-white border-blue-600 mr-1.5 last:mr-0">-->
                                    <!--                                        &lt;!&ndash;&ndash;&gt;<span>Small Teams</span>-->
                                    <!--                                    </div>-->
                                </div>
                            </div>
                            <div class="flex flex-shrink items-center justify-center">
                                <div class="justify-between items-center flex">
                                    <div class="flex flex-shrink items-center justify-center">
                                        <div class="text-right"><h1 class="text-2xl">Pro</h1>
                                            <!--                                            <h1 class="text-lg text-gray-500 dark:text-gray-400">Most Popular</h1>-->
                                        </div>
                                    </div>
                                    <div class="flex flex-shrink items-center justify-center"><!----></div>
                                </div>
                            </div>
                        </div>
                    </header>
                    <div class="p-6 flex-1">
                        <div class="space-y-6">
                            <div class="flex items-center"><span
                                class="inline-flex justify-center items-center w-8 h-8"><svg viewBox="0 0 24 24"
                                                                                             width="24" height="24"
                                                                                             class="inline-block"><path
                                fill="currentColor" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"></path></svg>
                                <!----></span><span class="text-lg ml-3"><b>10</b> Campaigns</span></div>
                            <div class="flex items-center"><span
                                class="inline-flex justify-center items-center w-8 h-8"><svg viewBox="0 0 24 24"
                                                                                             width="24" height="24"
                                                                                             class="inline-block"><path
                                fill="currentColor" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"></path></svg>
                                <!----></span><span class="text-lg ml-3"><b>15</b> Referrers per Campaign</span></div>
                            <div class="flex items-center"><span
                                class="inline-flex justify-center items-center w-8 h-8"><svg viewBox="0 0 24 24"
                                                                                             width="24" height="24"
                                                                                             class="inline-block"><path
                                fill="currentColor" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"></path></svg>
                                <!----></span><span class="text-lg ml-3"><b>Analytics</b> (all of starter, browsers & platforms)</span>
                            </div>
                            <div class="flex items-center"><span
                                class="inline-flex justify-center items-center w-8 h-8"><svg viewBox="0 0 24 24"
                                                                                             width="24" height="24"
                                                                                             class="inline-block"><path
                                fill="currentColor" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"></path></svg>
                                <!----></span><span class="text-lg ml-3"><b>Mail</b> Notifications</span></div>
                        </div>
                    </div>
                    <div class="border-gray-100 dark:border-gray-700 p-6 border-t">
                        <div class="flex items-center justify-start flex-wrap -mb-3">
                            <!--                            <button-->
                            <!--                                class="inline-flex cursor-pointer justify-center items-center whitespace-nowrap ring-blue-700 focus:outline-none transition-colors duration-150 border bg-blue-500 text-white border-blue-600 hover:bg-blue-600 py-2 px-3 focus:ring rounded flex-1 mr-3 last:mr-0 mb-3"-->
                            <!--                                type="button">&lt;!&ndash;&ndash;&gt;<span class="pl-2 pr-2">Subscribe</span>&lt;!&ndash;&ndash;&gt;&lt;!&ndash;&ndash;&gt;&lt;!&ndash;&ndash;&gt;-->
                            <!--                            </button>-->
                            <div class="w-full text-center">
                                <span><small class="items-center">14 days trial period</small></span>
                            </div>
                            <paddle-button :url="proPayLink" :plan="'pro'">Subscribe</paddle-button>
                        </div>
                    </div>
                </div>
                <div
                    class="rounded-lg flex flex-col bg-white border border-gray-100 dark:bg-gray-900 dark:border-gray-900 lg:my-12 xl:mr-12">
                    <header class="border-b border-gray-100 dark:border-gray-700 p-6">
                        <div class="justify-between items-center flex">
                            <div class="flex flex-shrink items-center justify-center">
                                <div>
                                    <div class="justify-end items-center flex">
                                        <div class="flex flex-shrink items-center justify-center"><h3 class="text-4xl">
                                            $ </h3></div>
                                        <div class="flex flex-shrink items-center justify-center"><h1
                                            class="text-5xl font-black">25</h1></div>
                                        <div class="flex flex-shrink items-center justify-center"><h1
                                            class="text-xl text-gray-500 dark:text-gray-400"> /mo</h1></div>
                                    </div>
                                    <!--                                    <div-->
                                    <!--                                        class="inline-flex items-center border py-0.5 px-2 text-xs rounded-lg bg-gray-100 text-black border-gray-200 dark:border-gray-400 mr-1.5 last:mr-0">-->
                                    <!--                                        &lt;!&ndash;&ndash;&gt;<span>Large Teams</span>-->
                                    <!--                                    </div>-->
                                </div>
                            </div>
                            <div class="flex flex-shrink items-center justify-center">
                                <div class="justify-between items-center flex">
                                    <div class="flex flex-shrink items-center justify-center">
                                        <div class="text-right"><h1 class="text-2xl">Premium</h1>
                                            <!--                                            <h1 class="text-lg text-gray-500 dark:text-gray-400">All options</h1>-->
                                        </div>
                                    </div>
                                    <div class="flex flex-shrink items-center justify-center"><span
                                        class="inline-flex justify-center items-center w-16 h-16 ml-6 lg:hidden"><svg
                                        viewBox="0 0 24 24" width="48" height="48" class="inline-block"><path
                                        fill="currentColor"
                                        d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z"></path></svg>
                                        <!----></span></div>
                                </div>
                            </div>
                        </div>
                    </header>
                    <div class="lg:block p-6 flex-1">
                        <div class="space-y-6">
                            <div class="flex items-center"><span
                                class="inline-flex justify-center items-center w-8 h-8"><svg viewBox="0 0 24 24"
                                                                                             width="24" height="24"
                                                                                             class="inline-block"><path
                                fill="currentColor" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"></path></svg>
                                <!----></span><span class="text-lg ml-3"><b>All</b> in Pro</span></div>
                            <div class="flex items-center"><span
                                class="inline-flex justify-center items-center w-8 h-8"><svg viewBox="0 0 24 24"
                                                                                             width="24" height="24"
                                                                                             class="inline-block"><path
                                fill="currentColor" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"></path></svg>
                                <!----></span><span class="text-lg ml-3"><b>Multiple</b> users</span></div>
                            <div class="flex items-center"><span
                                class="inline-flex justify-center items-center w-8 h-8"><svg viewBox="0 0 24 24"
                                                                                             width="24" height="24"
                                                                                             class="inline-block"><path
                                fill="currentColor" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"></path></svg>
                                <!----></span><span class="text-lg ml-3"><b>Analytics</b> all in Pro, devices, traffic source & export</span>
                            </div>
                        </div>
                    </div>
                    <div class="border-gray-100 dark:border-gray-700 lg:block p-6 border-t">
                        <div class="flex items-center justify-start flex-wrap -mb-3">
                            <paddle-button :url="premiumPayLink" :plan="'premium'">Subscribe</paddle-button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </backend-layout>
</template>

<script>
import BackendLayout from "@/Layouts/BackendLayout";
import Button from "@/Jetstream/Button";
import PaddleButton from "@/Components/PaddleButton";

export default {
    name: "Subscriptions",
    props: {
        starterPayLink: String,
        proPayLink: String,
        premiumPayLink: String,
    },
    components: {PaddleButton, Button, BackendLayout}
}
</script>

<style scoped>

</style>
